export default {
  DOWNLOAD_START: 'Wird heruntergeladen… Bitte warten…',
  DOWNLOAD_SUCCESS: 'Vielen Dank! Sie können dieses Fenster nun schließen.'
}
